export default __webpack_public_path__ + "static/media/picture.6f704f67.jpeg";